import { BaseSubscriptionPlan } from '@wwe-portal/entities/subscription.type';
import { sendGTMEvent } from './gtm-helper';

export const sendSubscriptionPaymentClosedEvent = (
  plan: BaseSubscriptionPlan
) => {
  sendGTMEvent({
    category: 'Xsolla Popup Closed',
    action: `xsolla_popup/${plan.displayName}/clicked_close`,
    event: 'xsolla_popup_closed',
  });
};
